<template>
    <div>
        <el-menu :default-active="activeId" :unique-opened="true" :router="true" class="el-menu-vertical-demo">
            <el-submenu :index="item.Url" v-if="item.ChildNavigations" v-for="(item,index) in menu" :key="item.NavigationId">
                <template slot="title">
                    <!-- <svg class="icon" aria-hidden="true">
                        <use :xlink:href="item.Iconurl"></use>
                    </svg> -->
                    <a href="javascript:void(0)" class="crm-menu-icon"><img :src="item.Iconurl" v-if="item.Iconurl"/></a>
                    {{item.Title}}
                </template>
                <el-menu-item :key="item2.NavigationId" :route="{path:`${item2.Url}`}" v-for="(item2,index2) in item.ChildNavigations" :index="item2.Url">
                    <!-- <a v-if="item2.AppId != 130555 " href="/" style="display:block;">{{item2.Title}}</a> -->
                    <span class="beyond-hidden" style="margin-right: -20px;" :title="item2.Title">{{item2.Title}}</span>
                </el-menu-item>
            </el-submenu>
            <!-- 没有二级菜单的 -->
            <template v-for="(item3,index3) in menu">
                <li v-if="item3.Path === 'supervise'" role="menuitem" tabindex="-1" class="el-menu-item" style="padding-left: 20px;outline: none" @click="clickAction(item3)">
                    <span >{{item3.Title}}</span>
                </li>
                <el-menu-item v-else-if="!item3.ChildNavigations" :key="item3.NavigationId" :route="{path:`${item3.Url}`}"  :index="item3.Url  || Math.random()">
                    <!-- <svg class="icon" aria-hidden="true">
                        <use :xlink:href="item3.Iconurl"></use>
                    </svg> -->
                    <a href="javascript:void(0)" class="crm-menu-icon"><img :src="item3.Iconurl" v-if="item3.Iconurl"/></a>
                    <!-- <a v-if="item3.AppId != 130555 " href="/" style="display:block;">{{item3.Title}}</a> -->
                    <span>{{item3.Title}}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>
<style scoped>
    .crm-menu-icon {
        height: 15px;
        width: 15px;
        display: inline-flex;
        margin-right: 4px;
    }
    .crm-menu-icon img{
        width: 100%;
        height: 100%;
    }
</style>
<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import { parseUrl } from 'base';
    import { CRM_CURRENT_LEVEL_ONE_MENU, CRM_MENU } from '../util/keys';
    import { Row, Col, Menu, Submenu, MenuItem, MenuItemGroup} from 'element-ui';
    import {GetSupervisionUrl} from "~/js/api/navbar";
    Vue.component(Row.name, Row);
    Vue.component(Col.name, Col);
    Vue.component(Menu.name, Menu);
    Vue.component(Submenu.name, Submenu);
    Vue.component(MenuItem.name, MenuItem);
    Vue.component(MenuItemGroup.name, MenuItemGroup);
    export default {
        name:'crm-menu',
        computed:{
            ...mapState({
                menu: state=> state.navigation.currentSubMenu
            }),
            activeId(){
                return this.$store.state.navigation.currentTabId;
            }
        },
        methods: {
            clickAction(item) {
                if (item.Path === "supervise") {
                    GetSupervisionUrl().then(ret => {
                        if (ret.status === 0 && ret.result) {
                            window.open(ret.result)
                        } else {
                            this.$message({
                                type: 'warning',
                                message: ret.info || "获取链接失败"
                            })
                        }
                    })
                }
            }
        },
        mounted() {
            //this.$store.dispatch('updateCurrentTabId',parseUrl().nid)
            this.$store.dispatch('updateCurrentTabId',this.$route.path);
        },
    }
</script>
